// Industries and Industries Details Specific Logic
$(function () {
  const body = document.body;

  // Wrap tables inside report content to make them scrollable horizontally
  const wrapTablesResponsive = () => {
    $('.report-tab-pane table').each(function () {
      const $table = $(this);
      if (!$table.parent().hasClass('table-responsive') && !$table.parent().hasClass('methodology-table-wrap')) {
        $table.wrap('<div class="table-responsive"></div>');
      }
    });
  };
  wrapTablesResponsive();

  // --- GLOBAL MODAL FUNCTIONS ---

  window.setIsPopup = function (enabled) {
    const form = document.getElementById("pmrModalForm");
    if (!form) return;
    const existing = form.querySelector('input[name="ispopup"]');
    if (enabled) {
      if (!existing) {
        const inp = document.createElement("input");
        inp.type = "hidden";
        inp.name = "ispopup";
        inp.value = "true";
        form.appendChild(inp);
      }
    } else {
      if (existing) existing.remove();
    }
  }

  function openLeadModal(type, reportId = "0", reportName = "", ctaText = "", formType = null) {
    // 1. Ensure Modal HTML is present in DOM
    if (window.PMR_Modal) {
      window.PMR_Modal.ensureLoaded("pmrLeadModal", "pmrLeadModalTemplate");
    }

    const modal = document.getElementById("pmrLeadModal");
    if (!modal) return;

    // Populate country selects after template clone (they start empty)
    if (window._pmrBuildCountries) {
      modal.querySelectorAll('select.custom-popup-country').forEach(function (s) {
        window._pmrBuildCountries(s, false);
      });
    }

    const modalForm = modal.querySelector("#pmrModalForm");
    const modalHeading = modal.querySelector("#modalHeading");
    const modalSubheading = modal.querySelector("#modalSubheading");
    const modalBtnText = modal.querySelector("#modalBtnText");
    const reportNameField = modal.querySelector("#hidden-report-name");

    if (!modalForm) return;

    // Reset success message
    const successMsg = modal.querySelector("#modalSuccessMsg");
    if (successMsg) successMsg.style.display = "none";
    modalForm.style.display = "grid";

    // Set Report Name (from data-attribute or breadcrumb)
    const reportTitle = reportName || (reportNameField ? reportNameField.textContent.trim() : "");

    // Set IDs and Types
    const idField = modal.querySelector("#modalHiddenReportId");
    if (idField && reportId !== "0") {
      idField.value = reportId;
    }

    const typeField = modal.querySelector("#modalFormRequestType");
    if (typeField) {
      if (formType) {
        typeField.value = formType;
      } else {
        if (type === "sample") typeField.value = "0";
        else if (type === "custom") typeField.value = "2";
        else typeField.value = "1";
      }
    }

    // Show/Hide Customization Options
    const optionsWrap = modal.querySelector("#purchase-options-wrap");
    if (optionsWrap) {
      optionsWrap.style.display =
        type === "custom" || formType === "2" ? "block" : "none";
    }

    const nameField = modal.querySelector("#modalFormName");
    if (nameField) {
      if (type === "sample") nameField.value = "Download Sample Report";
      else if (type === "custom") nameField.value = "Request Customization";
      else nameField.value = "Speak to Analyst";
    }

    // Update Headings based on type
    if (modalHeading) {
      if (type === "sample") {
        modalHeading.innerText = `Download Sample Report of ${reportTitle}`;
      } else if (type === "custom") {
        modalHeading.innerText = `Customize the request for ${reportTitle}`;
      } else {
        modalHeading.innerText = `Speak to Analyst for ${reportTitle}`;
      }
    }

    if (modalSubheading) {
      if (type === "sample") {
        modalSubheading.innerText = "Please fill out the form to receive sample pages of the report.";
      } else if (type === "custom") {
        modalSubheading.innerText = "Please fill out the form to request a customized copy of the research report.";
      } else {
        modalSubheading.innerText = "Please fill out the form to speak with one of our research analysts.";
      }
    }

    if (modalBtnText) {
      modalBtnText.innerText = "SUBMIT";
    }

    // Reset Turnstile if it exists
    if (window.PMR_Modal) {
      const turnstileContainer = modal.querySelector(".cf-turnstile")?.id || "modal-turnstile-container";
      window.PMR_Modal.initTurnstile(turnstileContainer);
    }

    // Open Modal
    modal.classList.add("active");
    body.style.overflow = "hidden";
  }

  function closeLeadModalFunc() {
    const modal = document.getElementById("pmrLeadModal");
    if (!modal) return;

    modal.classList.remove("active");
    body.style.overflow = "";

    // Clear errors and reset form
    const modalForm = modal.querySelector("#pmrModalForm");
    const errorMessages = modal.querySelectorAll(".error-msg");
    if (errorMessages && errorMessages.length) {
      errorMessages.forEach((el) => {
        el.style.display = "none";
      });
    }
    if (modalForm) modalForm.reset();
  }

  // --- GLOBAL MODAL LISTENERS ---

  // --- UNIVERSAL CLICK LISTENER FOR MODALS ---
  document.addEventListener("click", function (e) {
    // 1. Handle Lead Modal Triggers
    const leadTrigger = e.target.closest(
      ".open-sample-popup, .open-custom-popup, [data-form-type], [data-form-data]",
    );
    if (leadTrigger) {
      const href = leadTrigger.getAttribute("href") || "";
      const reportId =
        leadTrigger.getAttribute("data-report-id") ||
        leadTrigger.dataset.reportId ||
        "0";
      const reportName = leadTrigger.getAttribute("data-report-heading") || "";
      const formType =
        leadTrigger.getAttribute("data-form-type") ||
        leadTrigger.getAttribute("data-form-data");
      const isSample =
        leadTrigger.classList.contains("open-sample-popup") ||
        formType === "0" ||
        href.includes("/request-for-sample");
      const isCustom =
        leadTrigger.classList.contains("open-custom-popup") ||
        formType === "2" ||
        href.includes("/request-for-customization");
      const isAnalyst =
        leadTrigger.classList.contains("open-analyst-popup") ||
        formType === "1" ||
        href.includes("/talk-to-our-analyst");

      let type = "sample";
      if (isCustom) type = "custom";
      else if (isAnalyst) type = "analyst";

      // Extract CTA Text and clean it (remove extra whitespace/newlines)
      const ctaText =
        leadTrigger.innerText.replace(/\s+/g, " ").trim() ||
        leadTrigger.textContent.trim();

      e.preventDefault();
      setIsPopup(false);
      openLeadModal(
        type,
        reportId,
        reportName,
        ctaText,
        formType,
      );
      return;
    }

    // 2. Handle Profile Modal Triggers
    const profileTrigger = e.target.closest(".profile-trigger");
    if (profileTrigger) {
      const modal = document.getElementById("teamProfileModal");
      if (!modal) return;
      e.preventDefault();
      const ds = profileTrigger.dataset;
      const img = modal.querySelector(".profile-card__image");
      if (img) {
        img.src = ds.image || "";
        img.alt = ds.name || "";
      }
      modal.querySelector(".profile-card__name").textContent = ds.name || "";
      modal.querySelector(".profile-card__title").textContent =
        ds.designation || "";
      const desc = modal.querySelector(".profile-card__description");
      if (desc) {
        desc.textContent = ds.bio || "";
        desc.hidden = !ds.bio;
      }
      const link = modal.querySelector(".img-box a");
      if (link) {
        if (ds.profileUrl) {
          link.setAttribute("href", ds.profileUrl);
          link.style.display = "";
        } else {
          link.setAttribute("href", "");
          link.style.display = "none";
        }
      }
      modal.classList.add("active");
      modal.setAttribute("aria-hidden", "false");
      body.style.overflow = "hidden";
      return;
    }

    // 3. Handle Modal Closures
    if (
      e.target.id === "closeLeadModal" ||
      e.target.closest("#closeLeadModal") ||
      e.target.id === "pmrLeadModal"
    ) {
      closeLeadModalFunc();
      return;
    }

    const teamModal = document.getElementById("teamProfileModal");
    if (
      e.target === teamModal ||
      e.target.closest(".pmr-custom-modal__close")
    ) {
      if (teamModal) {
        teamModal.classList.remove("active");
        teamModal.setAttribute("aria-hidden", "true");
        body.style.overflow = "";
      }
    }
  });

  // Handle URL params for auto-opening modals (e.g., from Blog/Press Release sticky buttons)
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("open-sample")) {
    setTimeout(() => {
      openLeadModal("sample");
    }, 800);
  } else if (urlParams.has("open-custom") || urlParams.has("open-sample-2")) {
    setTimeout(() => {
      openLeadModal("custom");
    }, 800);
  }

  // AJAX form submit handler (Delegated for dynamic content)
  document.addEventListener("submit", function (e) {
    if (e.target.id !== "pmrModalForm") return;

    const modalForm = e.target;
    e.preventDefault();
    let isValid = true;
    const inputs = modalForm.querySelectorAll("input, textarea, select");

    function showFormError(el, msg) {
      el.classList.add("error");
      const errGrp = el.closest(".form-group");
      const errSpan = errGrp ? errGrp.querySelector(".error-msg") : null;
      if (errSpan) {
        errSpan.innerText = msg;
        errSpan.style.display = "block";
      }
    }

    modalForm
      .querySelectorAll(".error-msg")
      .forEach((err) => (err.style.display = "none"));
    inputs.forEach((i) => i.classList.remove("error"));

    const nameInput = modalForm.querySelector(
      'input[name="fname"], input[name="name"]',
    );
    if (nameInput && !nameInput.value.trim()) {
      showFormError(nameInput, "Field is required");
      isValid = false;
    }

    const emailInput = modalForm.querySelector('input[name="email"]');
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailInput && !emailInput.value.trim()) {
      showFormError(emailInput, "Field is required");
      isValid = false;
    } else if (emailInput && !emailRegex.test(emailInput.value)) {
      showFormError(emailInput, "Please enter a valid business email");
      isValid = false;
    }

    const phoneInput = modalForm.querySelector('input[name="phone"]');
    if (phoneInput && phoneInput.value.trim()) {
      const phoneDigits = phoneInput.value.replace(/\D/g, "");
      if (phoneDigits.length < 5 || phoneDigits.length > 15) {
        showFormError(
          phoneInput,
          "Please enter a valid phone number (5-15 digits)",
        );
        isValid = false;
      } else {
        phoneInput.value = phoneDigits;
      }
    }

    const companyInput = modalForm.querySelector('input[name="company"]');
    if (companyInput && typeof window.checkCompany === "function") {
      if (!window.checkCompany(companyInput, $(modalForm))) {
        isValid = false;
      }
    }

    const countryInput = modalForm.querySelector('select[name="country"]');
    if (countryInput && !countryInput.value) {
      showFormError(countryInput, "Please select your country");
      isValid = false;
    }

    if (typeof turnstile !== "undefined") {
      const turnstileElement = modalForm.querySelector(".cf-turnstile");
      if (turnstileElement) {
        const turnstileResponse = turnstile.getResponse(turnstileElement);
        if (!turnstileResponse) {
          showFormError(
            turnstileElement,
            "Please complete the Turnstile verification.",
          );
          isValid = false;
        }
      }
    }

    if (!isValid) return;

    const fd = new FormData(modalForm);
    const submitBtn = window.setFormSubmittingState(modalForm);
    if (!submitBtn) return;

    const endpoint =
      document.querySelector(".report-listing-page") &&
        !document.querySelector(".report-detail-inner-layout")
        ? "/submit-request-sample"
        : "/submit-request-sample-popup";

    fetch(endpoint, {
      method: "POST",
      body: fd,
      headers: { "X-Requested-With": "XMLHttpRequest" },
    })
      .then((res) => {
        if (res.redirected) {
          modalForm.reset();
          window.location.href = res.url;
          return null;
        }
        return res.json().catch(() => res.text());
      })
      .then((data) => {
        if (!data) return;
        modalForm.reset();
        window.location.href =
          data && data.redirect ? data.redirect : "/thank-you";
      })
      .catch(() => {
        modalForm.reset();
        window.location.href = "/thank-you";
      });
  });

  // Delegated input listeners for validation
  document.addEventListener("keydown", function (e) {
    const input = e.target;
    if (
      !input ||
      !input.closest("#pmrModalForm") ||
      (input.tagName !== "INPUT" &&
        input.tagName !== "TEXTAREA" &&
        input.tagName !== "SELECT")
    )
      return;

    if (e.key === " " || e.keyCode === 32) {
      if (input.name === "email" || input.name === "phone") {
        e.preventDefault();
      } else if (input.selectionStart === 0) {
        e.preventDefault();
      }
    }
  });

  document.addEventListener("input", function (e) {
    const input = e.target;
    if (
      !input ||
      !input.closest("#pmrModalForm") ||
      (input.tagName !== "INPUT" &&
        input.tagName !== "TEXTAREA" &&
        input.tagName !== "SELECT")
    )
      return;

    if (input.name === "email" || input.name === "phone") {
      input.value = input.value.replace(/\s/g, "");
    } else {
      input.value = input.value.replace(/^\s+/g, "");
    }

    if (input.classList.contains("alpha-only")) {
      input.value = input.value.replace(/[^a-zA-Z\s]/g, "");
      input.value = input.value.replace(/^\s+/g, "");
    }

    if (input.classList.contains("numeric-only")) {
      input.value = input.value.replace(/[^0-9]/g, "");
      if (input.value.length > 15) input.value = input.value.substring(0, 15);
    }
  });

  // --- PAGE SPECIFIC LOGIC ---

  if (
    document.querySelector(".report-listing-page") &&
    !document.querySelector(".report-detail-inner-layout")
  ) {
    // Listing Page Search
    $("#searchTxtIndustries").keyup(function () {
      var searchTxt = $(this).val();
      var $searchForm = $("#search-form-industries");
      var category_id = $searchForm.attr("data-category-id") || "";
      var subcategory_id = $searchForm.attr("data-subcategory-id") || "";

      if (searchTxt.length >= 3) {
        $.ajax({
          type: "GET",
          url: "/HomeController/autoSearchResult",
          dataType: "JSON",
          data: {
            searchTxt: searchTxt,
            category_id: category_id,
            subcategory_id: subcategory_id,
          },
          success: function (data) {
            $("#suggesstion-box-industries").empty();
            if (data.length > 0) {
              $.each(data, function (i, item) {
                var url = item.url.replace(/ /g, "-");
                $("#suggesstion-box-industries")
                  .show()
                  .append(
                    "<p><a href='" +
                    url +
                    "' target='_blank'>" +
                    item.title +
                    "</a></p>",
                  );
              });
            } else {
              $("#suggesstion-box-industries").hide();
            }
          },
        });
      } else {
        $("#suggesstion-box-industries").empty().hide();
      }
    });

    $(document).mouseup(function (e) {
      var container = $("#suggesstion-box-industries, #searchTxtIndustries");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $("#suggesstion-box-industries").hide();
      }
    });

  } else if (
    document.getElementById("myID") ||
    document.querySelector(".report-detail-inner-layout")
  ) {
    // Details Page Logic
    const descriptionPane = document.getElementById("home");
    const indexList = document.querySelector(".index-h2-list");

    if (descriptionPane && descriptionPane.classList.contains("active") && indexList) {
      const updateUrlToReport = () => {
        const reportPage = document.querySelector(".report-listing-page");
        if (reportPage && reportPage.dataset.reportUrl) {
          const reportUrl = reportPage.dataset.reportUrl;
          if (!reportUrl) return; // Do nothing if on global pages
          const pn = window.location.pathname;
          if (
            pn.includes("/toc") ||
            pn.includes("/analysis-type")
          ) {
            window.history.replaceState(null, "", reportUrl);
          }
        }
      };

      const headings = document.querySelectorAll(
        ".report-main-content-header-groups h2, .key-insights-section h2, .industry-overview-section h2, #home h2",
      );
      if (headings.length > 0) {
        const reportPage = document.querySelector(".report-listing-page");
        const baseReportUrl =
          reportPage && reportPage.dataset.reportUrl
            ? reportPage.dataset.reportUrl
            : "";
        indexList.innerHTML = "";

        const headingsArr = Array.from(headings);
        const faqIdx = headingsArr.findIndex((h) =>
          h.innerText.trim().toLowerCase().includes("faq's"),
        );
        const filteredHeadings =
          faqIdx !== -1 ? headingsArr.slice(0, faqIdx + 1) : headingsArr;

        filteredHeadings.forEach((h, i) => {
          if (!h.id) h.id = "idx-heading-" + i;
          const li = document.createElement("li");
          li.classList.add("index-h2-li");
          li.innerHTML = `<a href="${baseReportUrl}#${h.id}" class="index-h2-link">${h.innerText}</a>`;
          li.querySelector("a").addEventListener("click", function (e) {
            const currentUrl = window.location.href
              .split(/[?#]/)[0]
              .replace(/\/$/, "");
            const targetUrl = this.href.split(/[?#]/)[0].replace(/\/$/, "");
            if (currentUrl !== targetUrl) return;

            e.preventDefault();
            updateUrlToReport();
            document
              .querySelectorAll(".report-tab-nav .accordion-item")
              .forEach((item) => item.classList.remove("active"));
            const indexItem = document.querySelector(".report-index-item");
            if (indexItem) indexItem.classList.add("active");
            document
              .querySelectorAll(".report-tab-pane")
              .forEach((p) => p.classList.remove("active"));
            descriptionPane.classList.add("active");

            const headerGroups = document.querySelector(
              ".report-main-content-header-groups",
            );
            if (headerGroups) headerGroups.style.display = "block";

            const currentWrap = document.querySelector(
              ".report-index-item .index-collapse-inner",
            );
            if (currentWrap) {
              $(currentWrap).slideDown();
              currentWrap.classList.add("auto-opened");
            }

            this.classList.add("active");
            const targetPos =
              h.getBoundingClientRect().top + window.pageYOffset - 180;
            window.scrollTo({ top: targetPos, behavior: "smooth" });
          });
          indexList.appendChild(li);
        });

        const observer = new IntersectionObserver(
          (entries) => {
            const reportPage = document.querySelector(".report-listing-page");
            const allowedBaseUrl = reportPage
              ? reportPage.dataset.reportUrl
              : "";
            const currentUrl = window.location.href
              .split(/[?#]/)[0]
              .replace(/\/$/, "");
            if (
              !descriptionPane.classList.contains("active") ||
              (allowedBaseUrl &&
                currentUrl !== allowedBaseUrl.replace(/\/$/, ""))
            )
              return;

            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const id = entry.target.getAttribute("id");
                indexList.querySelectorAll("li").forEach((li) => {
                  li.classList.remove("active");
                  const link = li.querySelector("a");
                  if (link && link.getAttribute("href").split("#")[1] === id) {
                    li.classList.add("active");
                    const container = document.querySelector(
                      ".index-collapse-inner",
                    );
                    if (container && $(container).is(":visible")) {
                      container.scrollTo({
                        top:
                          li.offsetTop -
                          container.clientHeight / 2 +
                          li.offsetHeight / 2,
                        behavior: "smooth",
                      });
                    }
                  }
                });
              }
            });
          },
          { root: null, rootMargin: "-180px 0px -70% 0px", threshold: 0 },
        );

        filteredHeadings.forEach((h) => observer.observe(h));

        let indexAutoOpened = false;
        let scrollTicking = false;
        // --- Consolidated Tab & Index Logic ---
        const $panes = $(".report-tab-pane");
        const $indexInner = $(".report-index-item .index-collapse-inner");

        window.addEventListener("scroll", function () {
          if (!window.location.href.includes("industry-analysis")) return;
          if (!scrollTicking) {
            window.requestAnimationFrame(function () {
              const isActive = $("#home").hasClass("active");
              if (!isActive) {
                if ($indexInner.is(":visible")) {
                  $indexInner.hide();
                  $(".report-index-item").removeClass("active");
                }
              } else if (!indexAutoOpened && $(".report-detail-sidebar")[0]?.getBoundingClientRect().top <= 200) {
                $indexInner.slideDown(400);
                $(".report-index-item").addClass("active");
                indexAutoOpened = true;
              }
              scrollTicking = false;
            });
            scrollTicking = true;
          }
        }, { passive: true });

        // Generic Tab Switcher
        $(document).on("click", ".report-tab-nav .accordion-link, .mob-link-item", function (e) {
          const targetId = $(this).attr("href");
          if (!targetId || !targetId.startsWith("#")) return;

          e.preventDefault();
          const $targetPane = $(targetId);
          if (!$targetPane.length) return;

          // Switch Panes
          $panes.removeClass("active");
          $targetPane.addClass("active");

          // Sidebar State
          $(".report-tab-nav .accordion-item").removeClass("active");
          $(this).closest(".accordion-item").addClass("active");

          // URL Update
          const reportUrl = $(".report-detail-page").data("report-url");
          if (reportUrl) window.history.replaceState(null, null, reportUrl);

          if (window.innerWidth < 600) {
            $(".report-detail-main")[0]?.scrollIntoView({ behavior: "smooth" });
          }
        });

        // Index Toggle: Force switch to Description if not active
        $(document).on("click", ".index-trigger", function (e) {
          if (!window.location.href.includes("industry-analysis")) return;
          e.preventDefault();

          const accordionItem = $(this).closest(".accordion-item, .sidebar-section");
          const wrap = accordionItem.find(".index-collapse-inner");

          if ($('.toc-page').hasClass('active') || $('#methodology-pane').hasClass('active')) {
            const reportUrl = $(this).attr("href") || $(".report-detail-page").data("report-url");
            if (reportUrl) {
              window.location.href = reportUrl;
              return;
            }
          }

          if (!$("#home").hasClass("active")) {
            e.stopImmediatePropagation();
            $(".report-tab-nav .accordion-link[href='#home']").trigger('click');
            wrap.slideDown();
            $(this).addClass("active");
            accordionItem.addClass("active");
          } else {
            // Already on home: toggle visibility
            if (wrap.length) {
              wrap.slideToggle();
              $(this).toggleClass("active");
              accordionItem.toggleClass("active");
              $(this).find(".icon-chevron").toggleClass("rotate");
            }
          }
        });

      }
    }

    // FAQ Accordion
    const faqSection = document.querySelector(".report-faq");
    if (faqSection) {
      faqSection
        .querySelectorAll('button[id^="accordion-button-"]')
        .forEach((button) => {
          button.addEventListener("click", function (e) {
            e.preventDefault();
            const item = this.parentElement;
            const isExpanded = this.getAttribute("aria-expanded") === "true";
            faqSection
              .querySelectorAll('button[id^="accordion-button-"]')
              .forEach((btn) => {
                btn.setAttribute("aria-expanded", "false");
                btn.parentElement.classList.remove("active");
                const c = btn.parentElement.querySelector(".accordion-content");
                if (c) c.classList.remove("active");
              });
            if (!isExpanded) {
              this.setAttribute("aria-expanded", "true");
              item.classList.add("active");
              const c = item.querySelector(".accordion-content");
              if (c) c.classList.add("active");
            }
          });
        });
    }
  }

  // --- Tab URL Handling & Cleanup ---
  const updateUrlToReport = () => {
    const mainSection = document.querySelector(".reportpage-class");
    if (!mainSection) return;
    const reportUrl = mainSection.getAttribute("data-report-url");
    if (!reportUrl) return; // Important: Do nothing if we are on the global methodology page

    const descriptionPane = document.getElementById("home");
    if (!descriptionPane || !descriptionPane.classList.contains("active")) return;

    const pn = window.location.pathname;
    if (
      pn.includes("/toc") ||
      pn.includes("/analysis-type")
    ) {
      window.history.replaceState(null, "", reportUrl);
    }
  };
  updateUrlToReport();

  // --- CTA Cleanup & Styling ---
  const cleanupCTAs = () => {
    const ctas = document.querySelectorAll(
      'a[style*="background: #00BC99"], a[style*="background:#00BC99"], a[style*="background: #267cab"], a[style*="background:#267cab"]',
    );

    ctas.forEach((cta) => {
      const parentP = cta.closest("p");
      if (parentP) {
        const spans = parentP.querySelectorAll("span");
        const pText = parentP.textContent.trim();
        const ctaText = cta.textContent.trim();

        // Rule: If the paragraph has more than 2 spans, it's likely a text paragraph, not a standalone CTA.
        // Also check if there's significant text around the CTA.
        if (spans.length > 2 || pText.length > ctaText.length + 10) {
          // Paragraph context: Remove the ugly background but don't turn into a big button
          cta.style.background = "transparent";
          cta.style.color = "#0066b5";
          cta.style.padding = "0";
          cta.style.textDecoration = "underline";
          cta.style.fontWeight = "normal";
          cta.style.borderRadius = "0";
          return;
        }
      }

      // Standalone CTA context: Apply premium button style
      cta.className = "btn transparent-btn green-btn open-sample-popup";
      cta.style.cssText = ""; // Clear all inline styles
      cta.textContent = "Download Sample Report";
    });
  };

  // Run cleanup after initial load and after any tab/pagination changes
  $(document).on(
    "click",
    ".report-tab-links a, .publishReportPaginationClick",
    function () {
      setTimeout(cleanupCTAs, 500);
    },
  );

  setTimeout(cleanupCTAs, 1000);

  // --- Auto-Trigger Logic (Industry, Blog, Press) ---
  const initAutoPopupTrigger = () => {
    const triggerAutoPopup = () => {
      const isReportDetail = document.querySelector(".report-detail-page, .report-detail-inner-layout");
      const isBlogDetail = document.querySelector(".blog-details-page");
      const isPressDetail = document.querySelector(".press-detail-page");

      if (!isReportDetail && !isBlogDetail && !isPressDetail) return;

      const type = isReportDetail ? "report" : isBlogDetail ? "blog" : "pr";
      const storageKey = type + "ModalShown";
      const sessionKey = type + "PopupShown";

      const alreadyShown = sessionStorage.getItem(sessionKey) === "true";

      if (alreadyShown) return;

      const leadModal = document.getElementById("pmrLeadModal");
      const isAnyModalOpen = leadModal && leadModal.classList.contains("active");
      const overlay = document.getElementById("overlay");
      const isOverlayOpen = overlay && overlay.style.display !== "none";

      if (!isAnyModalOpen && !isOverlayOpen) {
        const sampleBtn = document.querySelector(".open-sample-popup, .download-btn");
        if (!sampleBtn) return;

        const reportName = sampleBtn.getAttribute("data-report-heading") || sampleBtn.getAttribute("data-report-name") || "";
        const reportId = sampleBtn.getAttribute("data-report-id") || sampleBtn.dataset.reportId || "0";

        if (!isReportDetail && window.PMR_Modal) {
          const templateId = "pmrLeadModalTemplate";
          const turnstileId = isBlogDetail ? "blog-modal-turnstile" : "pr-modal-turnstile";

          if (typeof window.PMR_Modal.ensureLoaded === 'function') {
            window.PMR_Modal.ensureLoaded("pmrLeadModal", templateId);
          }
          // Defer to next tick to allow DOM insertion from ensureLoaded
          setTimeout(() => {
            if (typeof window.PMR_Modal.initTurnstile === 'function') {
              window.PMR_Modal.initTurnstile(turnstileId);
            }
            openLeadModal("sample", reportId, reportName, "Download Sample Report");
            if (typeof window.setIsPopup === "function") window.setIsPopup(true);

            sessionStorage.setItem(sessionKey, "true");
          }, 50);
        } else {
          openLeadModal("sample", reportId, reportName, "Download Sample Report");
          if (typeof window.setIsPopup === "function") window.setIsPopup(true);

          sessionStorage.setItem(sessionKey, "true");
        }
      }
    };

    let hasTriggered = false;
    const handleScrollTrigger = () => {
      if (hasTriggered) return;
      const isReportDetail = document.querySelector(".report-detail-page, .report-detail-inner-layout");
      const isBlogDetail = document.querySelector(".blog-details-page");
      const isPressDetail = document.querySelector(".press-detail-page");
      const scrollPos = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const docHeight = document.documentElement.scrollHeight;

      let reachedTrigger = false;

      if (isReportDetail || isBlogDetail || isPressDetail) {
        // Report, Blog, and Press Release detail pages: trigger when user reaches 50% of the page height
        const scrollable = docHeight - windowHeight;
        const scrollPercent = scrollable > 0 ? (scrollPos / scrollable) * 100 : 100;
        reachedTrigger = scrollPercent >= 50;
      } else {
        reachedTrigger = scrollPos > 30;
      }

      if (reachedTrigger) {
        hasTriggered = true;
        window.removeEventListener("scroll", handleScrollTrigger);
        // Reduced from 2000ms to 800ms to improve UX without feeling instant
        setTimeout(triggerAutoPopup, 800);
      }
    };

    window.addEventListener("scroll", handleScrollTrigger, { passive: true });

    // Check immediately for cases where user is already scrolled to the bottom
    setTimeout(() => {
      if (!hasTriggered) {
        handleScrollTrigger();
      }
    }, 1000);
  };

  initAutoPopupTrigger();
});
